import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

export default function ({onChange = () => { }}) {
    const LEVEL_COUNT = 3;
    const DEFAULT_SORT = 1; // 👈 default sort value

    const sortTypes = [
        { name: "ASC", value: 1 },
        { name: "DSC", value: 2 },
    ];

    const sortLevels = [
        { name: "Village", value: 1 },
        { name: "Surname", value: 2 },
        { name: "First Name", value: 3 },
        { name: "Middle Name", value: 4 },
    ];

    const initialLevels = Array.from({ length: LEVEL_COUNT }, (_, i) => ({
        levelID: i,
        name: `Level ${i + 1}`,
        level: null,
        sort: null,
        disabledLevel: i !== 0,
        disabledSort: true,
    }));

    const [levels, setLevels] = useState(initialLevels);

    // Filter out already-selected levels
    const getAvailableLevels = (index) => {
        const selected = levels
            .slice(0, index)
            .map(l => l.level)
            .filter(Boolean);

        return sortLevels.filter(
            option => !selected.includes(option.value)
        );
    };

    // LEVEL CHANGE → auto-select SORT
    const handleLevelChange = (index, value) => {
        const updated = levels.map((item, i) => {
            if (i < index) return item;

            if (i === index) {
                return {
                    ...item,
                    level: value,
                    sort: DEFAULT_SORT,   // 👈 auto select sort
                    disabledSort: false,
                };
            }

            // clear & disable next
            return {
                ...item,
                level: null,
                sort: null,
                disabledLevel: true,
                disabledSort: true,
            };
        });

        // enable next level immediately
        if (updated[index + 1]) {
            updated[index + 1].disabledLevel = false;
        }

        setLevels(updated);
    };

    // SORT CHANGE (manual override)
    const handleSortChange = (index, value) => {
        const updated = levels.map((item, i) =>
            i === index ? { ...item, sort: value } : item
        );

        setLevels(updated);
    };


    useEffect(() => {
        var filter = levels.filter(e => e.sort != null && e.level != null).map(e => ({ level: e.levelID, levelValue: e.level, sort: e.sort }))
        if (filter.length > 0) {
            onChange(
                filter
            );
        }

    }, [levels]);


    return (
        <div className="grid">
            {levels.map((item, index) => (
                <div key={index} className="col-12 lg:col-4 md:col-6">
                    <div className="w-full report-sort-wrapper">
                        <div className="left">
                            <label>{item.name}</label>
                            <Dropdown
                                className="w-full"
                                options={getAvailableLevels(index)}
                                optionLabel="name"
                                optionValue="value"
                                value={item.level}
                                disabled={item.disabledLevel}
                                onChange={(e) => handleLevelChange(index, e.value)}
                            />
                        </div>

                        <div className="right">
                            <label>Sort</label>
                            <Dropdown
                                className="w-full"
                                options={sortTypes}
                                optionLabel="name"
                                optionValue="value"
                                value={item.sort}
                                disabled={item.disabledSort}
                                onChange={(e) => handleSortChange(index, e.value)}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
